import React, { Component } from "react";
import {
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
  NavbarToggler,
  Collapse,
  Nav
} from "reactstrap";
import { withNamespaces } from "react-i18next";
import GeoSearch from "./GeoSearch";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.toggleLanguage = this.toggleLanguage.bind(this);
    this.alternateLanguage = this.alternateLanguage.bind(this);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  toggleLanguage() {
    if (this.props.i18n.language === "en") {
      this.props.i18n.changeLanguage("cy");
    } else {
      this.props.i18n.changeLanguage("en");
    }
  }

  alternateLanguage() {
    if (this.props.i18n.language === "en") {
      return "cy";
    } else {
      return "en";
    }
  }

  render() {
    const { t } = this.props;

    return (
      <React.Fragment>
        <Navbar
          dark
          expand="md"
          style={{ backgroundColor: "#26559c", borderBottom: "8px solid #fff" }}
        >
          <NavbarBrand href="/" className="mr-auto">
            <img
              alt={t("layout-site-logo-alt-text")}
              width={30}
              style={{ borderRadius: "50%", backgroundColor: "#fff" }}
              src="/logo.png"
              className={"align-top"}
            />
            &nbsp;&nbsp;
            <span className={"d-none d-lg-inline"}>
              {t("layout-site-title")}
            </span>
          </NavbarBrand>
          <NavItem className={"searchNavItem flex-grow-1 px-3"}>
            <GeoSearch onSearchSelection={this.props.onSearchSelection} />
          </NavItem>
          <NavbarToggler onClick={this.toggle} className="" />
          <Collapse className={"flex-grow-0"} isOpen={this.state.isOpen} navbar>
            <Nav navbar>
              <NavItem>
                <NavLink href={"/?lng=" + this.alternateLanguage()}>
                  {t("layout-language-selector")}
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default withNamespaces()(Layout);



// WEBPACK FOOTER //
// ./src/Layout.jsx